// NO LONGER USED
// Instead, we're using Segment (to track an event, call window.analytics.track from any component).
import mixpanel from 'mixpanel-browser';

mixpanel.init('f91d8694933e356d9348dc73f25cb013');

export default mixpanel;
